import React, { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { Skeleton } from '@/components/ui/skeleton';
import { GRAVEDAD_COLOR, KpiCard, BajasPanel, CostesPanel, Panel, Bar } from './shared';
import { DateField } from '@/components/common/DateField';

const API = process.env.REACT_APP_BACKEND_URL;

export function KpisSection({ authHeader }) {
  const [filters, setFilters] = useState({ desde: '', hasta: '' });
  const params = Object.fromEntries(Object.entries(filters).filter(([, v]) => v !== ''));
  const { data, isLoading } = useQuery({
    queryKey: ['acc-kpis', params],
    queryFn: () => axios.get(`${API}/api/accidentes/kpis`, { headers: authHeader(), params }).then(r => r.data),
  });
  if (isLoading || !data) return <Skeleton className="h-60 w-full" />;
  const total = data.total || 0;
  return (
    <div className="space-y-4" data-testid="accidentes-kpis">
      <div className="flex gap-2">
        <DateField value={filters.desde} onChange={v => setFilters({ ...filters, desde: v })} className="w-36" testId="acc-kpis-desde" />
        <DateField value={filters.hasta} onChange={v => setFilters({ ...filters, hasta: v })} className="w-36" testId="acc-kpis-hasta" />
      </div>
      <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
        <KpiCard label="Total" value={data.total} color="#4A9EFF" />
        <KpiCard label="Hospitalizados" value={data.hospitalizados} color="#F44336" pct={total ? Math.round(data.hospitalizados / total * 100) : 0} />
        <KpiCard label="ETT" value={data.ett} color="#F97316" pct={total ? Math.round(data.ett / total * 100) : 0} />
        <KpiCard label="Tráfico" value={data.trafico} color="#FFC107" pct={total ? Math.round(data.trafico / total * 100) : 0} />
        <KpiCard label="Sin centro" value={data.sin_centro} color="#9E9E9E" pct={total ? Math.round(data.sin_centro / total * 100) : 0} />
      </div>
      {data.bajas && data.bajas.total_bajas > 0 && <BajasPanel bajas={data.bajas} />}
      {data.bajas && data.bajas.total_bajas > 0 && <CostesPanel filters={filters} authHeader={authHeader} />}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Panel title="Distribución por gravedad">
          {data.by_gravedad?.map((g, i) => <Bar key={i} label={g.label} n={g.n} max={total} color={GRAVEDAD_COLOR[g.label] || '#999'} />)}
        </Panel>
        <Panel title="Top modos de accidente">
          {data.top_modos?.map((m, i) => <Bar key={i} label={m.modo} n={m.n} max={Math.max(...data.top_modos.map(x => x.n))} color="#4A9EFF" />)}
        </Panel>
        <Panel title="Por día de la semana">
          {data.by_dia_semana?.map((d, i) => <Bar key={i} label={d.dia} n={d.n} max={Math.max(...data.by_dia_semana.map(x => x.n))} color="#00C853" />)}
        </Panel>
        <Panel title="Top 10 provincias">
          {data.by_provincia?.slice(0, 10).map((p, i) => <Bar key={i} label={p.provincia} n={p.n} max={Math.max(...data.by_provincia.slice(0, 10).map(x => x.n))} color="#9C27B0" />)}
        </Panel>
      </div>
    </div>
  );
}
